import { Injectable } from '@angular/core';

@Injectable()
export class ValidationService {

  constructor() { }

  CheckEmail(Email:string){
      var MatchOrNot = Email.match(
          /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
      if(!MatchOrNot)
          return false;
      else
          return true;  
  }

  CheckPhone(phone:string){
    var MatchOrNot = phone.match(/^(09\d{8})$/);
    if(!MatchOrNot)
        return false;
    else
        return true; 
  }
}
